function splitGraphemes(value) {
    if (typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function') {
        let segmenter = new Intl.Segmenter('ru', { granularity: 'grapheme' })
        return Array.from(segmenter.segment(value), ({ segment }) => segment)
    }
    return Array.from(value)
}

export function cleanAnimeTitle(value) {
    let original = String(value || '').replace(/\s+/gu, ' ').trim()
    if (!original) return ''

    let cleaned = original
        .replace(/^(?:\[[^\[\]\r\n]+\]\s*)+/u, '')
        .replace(/(?:\s*\[[^\[\]\r\n]+\])+$/u, '')
        .trim()

    return cleaned || original
}

export function formatAnimeNavTitle(value, maxLength = 32) {
    let title = cleanAnimeTitle(value)
    if (!title || maxLength <= 0) return ''

    let characters = splitGraphemes(title)
    if (characters.length <= maxLength) return title
    if (maxLength === 1) return '…'

    return `${characters.slice(0, maxLength - 1).join('').trimEnd()}…`
}
